import React, {Component} from "react";
import 'fontsource-roboto';
import {AppBar, Tab, Tabs} from "@material-ui/core";
import PropTypes from "prop-types";
import {fade, withStyles} from "@material-ui/core/styles";
import {fetchTopics, searchTopicsByTagID} from "../../actions";
import {connect} from "react-redux";
import {withSanctum} from "react-sanctum";
import {withRouter} from "react-router";

const styles = theme => ({
    root: {
        flexGrow: 1,
        width: '100%'
    },
    tagButton: {
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.5),
            cursor: 'pointer'
        },
    }

});

class ScrollableTabs extends Component {

    state = {
        value: 0,
        tags: this.props.tags,
        user: this.props.userData,
        conferences: this.props.conferences
    }

    componentDidUpdate() {
        if (this.props.userData && this.props.userData !== this.state.user) {
            this.setState({user: this.props.userData})
        }
        if (this.props.conferences && this.state.conferences !== this.props.conferences) {
            this.setState({
                conferences: this.props.conferences
            })
        }
        if (this.props.tags && this.state.tags !== this.props.tags) {
            this.setState({
                tags: this.props.tags
            })
        }
    }

    handleChange = (event, newValue) => {
        this.setState({value: newValue});
    };

    static TabPanel = {
        propTypes: {
            children: PropTypes.node,
            index: PropTypes.any.isRequired,
            value: PropTypes.any.isRequired,
        }
    };

    a11yProps = (index) => {
        return {
            id: `scrollable-auto-tab-${index}`,
            'aria-controls': `scrollable-auto-tabpanel-${index}`,
        };
    }

    fetchAllTopics = () => {
        if (this.state.user.isLogIn) {
            this.props.fetchTopics(this.state.conferences.data.uuid)
        } else {
            alert('Not Login')
        }
    }

    fetchTopicsByTagID = (tagId,userId, conferenceUUId) => {
        this.props.searchTopicsByTagID(tagId,userId, conferenceUUId)
    }

    render() {

        const {classes} = this.props;

        return (
            <div className={`${classes.root} scrollable-tabs__wrap`}>
                <AppBar position="static">
                    <Tabs
                        value={this.state.value}
                        onChange={this.handleChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="scrollable auto tabs example"
                    >
                        <Tab
                            onClick={() => {
                                this.fetchAllTopics()
                            }}
                            label='All'
                            key={'All'}
                            className='MuiChip-root'
                            {...this.a11yProps(0)} />
                        {
                            this.state.tags
                                ?
                                this.state.tags.map((tag, index) => {
                                    return (
                                        <Tab
                                            onClick={() => {
                                                this.fetchTopicsByTagID(tag.id, this.state.user.id, this.state.conferences.data.uuid)
                                            }}
                                            label={tag.name}
                                            key={tag.slug}
                                            className={`MuiChip-root ${classes.tagButton}`}
                                            {...this.a11yProps(index)}
                                        />
                                    )
                                })
                                :
                                null
                        }
                    </Tabs>
                </AppBar>
            </div>
        );
    }

}


const mapStateToProps = (state) => {
    return {
        tags: state.topics.tags,
        userData: state.user,
        conferences: state.conferences
    };
}

const mapDispatchToProps = dispatch => ({
    // drawerToggle: data => dispatch(drawerToggle(data))
    fetchTopics: (data) => dispatch(fetchTopics(data)),
    searchTopicsByTagID: (tagId, userId, conferenceUUId) => dispatch(searchTopicsByTagID(tagId,userId, conferenceUUId)),
})

export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(withSanctum(withRouter(ScrollableTabs))));


